import useStyles from './ReadyToTransform.styles'
import {
  DEBUG_MODE,
  MAIN_SITE_ENVIRONMENT_HOST,
  MAIN_SITE_ENVIRONMENT_HOST_ES,
  MAIN_SITE_ENVIRONMENT_HOST_FR,
  MAIN_SITE_ENVIRONMENT_HOST_KO,
  READY_TO_TRANSFORM_COMPONENT_ID,
} from '../../utilities/config'
import { isKorean, translate } from '../../utilities/language'
import { Button } from '@mantine/core'
import { HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS } from '../../utilities/styles'
import { IconExternalLink } from '@tabler/icons'

export default function ReadyToTransform(props: any) {
  const { classes } = useStyles()
  const selectedLanguage: any = props?.selectedLanguage
  const linkVariant: boolean = props?.linkVariant

  return (
    <section id={READY_TO_TRANSFORM_COMPONENT_ID + '-1'}>
      <div style={{ maxWidth: '750px' }}>
        <h2 className={classes.standardText + ' ' + classes.h2Tag}>
          {translate(
            <>Ready to Transform Your Venue?</>,
            <>¿Estás listo para transformar tu espacio?</>,
            <>Prêt à Transformer Votre Lieu&nbsp;?</>,
            <>
              <span aria-hidden={true} className={classes.asianTextBlock}>
                새로운
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                분위기를
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                만들
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                준비가
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                되셨나요?
              </span>
            </>,
            selectedLanguage
          )}
        </h2>
        <p className={classes.standardText + ' ' + classes.pJoinThousands}>
          {translate(
            <>
              Join thousands&nbsp;of businesses creating&nbsp;the
              perfect&nbsp;experience with{' '}
              {!linkVariant ? (
                <>Practical&nbsp;Stream</>
              ) : (
                <a
                  className={classes.aHref}
                  target="_blank"
                  href={MAIN_SITE_ENVIRONMENT_HOST}
                  title={
                    'Professional Background Music Streaming for Commercial Locations'
                  }
                  rel="noopener noreferrer"
                >
                  <span translate="no">
                    Practical&nbsp;
                    <span className={classes.spanPre}>
                      Stream&nbsp;
                      <IconExternalLink />
                    </span>
                  </span>
                </a>
              )}{' '}
              background music.
            </>,
            <>
              Únase a miles de empresas que crean la experiencia perfecta con la
              música de fondo de{' '}
              {!linkVariant ? (
                <>Practical&nbsp;Stream.</>
              ) : (
                <a
                  className={classes.aHref}
                  target="_blank"
                  href={MAIN_SITE_ENVIRONMENT_HOST_ES}
                  title={
                    'Transmisión de música de fondo profesional para ubicaciones comerciales'
                  }
                  rel="noopener noreferrer"
                >
                  <span translate="no">
                    Practical&nbsp;
                    <span className={classes.spanPre}>
                      Stream&nbsp;
                      <IconExternalLink />
                    </span>
                  </span>
                </a>
              )}
            </>,
            <>
              Rejoignez les milliers d'entreprises qui créent l'expérience
              parfaite grâce à la musique de fond{' '}
              {!linkVariant ? (
                <>Practical&nbsp;Stream.</>
              ) : (
                <a
                  className={classes.aHref}
                  target="_blank"
                  href={MAIN_SITE_ENVIRONMENT_HOST_FR}
                  title={
                    "Diffusion de musique d'ambiance professionnelle pour les lieux commerciaux."
                  }
                  rel="noopener noreferrer"
                >
                  <span translate="no">
                    Practical&nbsp;
                    <span className={classes.spanPre}>
                      Stream&nbsp;
                      <IconExternalLink />
                    </span>
                  </span>
                </a>
              )}{' '}
            </>,
            <>
              {!linkVariant ? (
                <>Practical&nbsp;Stream</>
              ) : (
                <a
                  className={classes.aHref}
                  target="_blank"
                  href={MAIN_SITE_ENVIRONMENT_HOST_KO}
                  title={'상업용 장소를 위한 전문 배경 음악 스트리밍'}
                  rel="noopener noreferrer"
                >
                  <span translate="no">
                    Practical&nbsp;
                    <span className={classes.spanPre}>
                      Stream&nbsp;
                      <IconExternalLink />
                    </span>
                  </span>
                </a>
              )}{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                배경
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                음악으로
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                완벽한
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                경험을
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                창출하는
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                수천
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                개의
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                기업에
              </span>{' '}
              <span aria-hidden={true} className={classes.asianTextBlock}>
                합류하세요.
              </span>
            </>,
            selectedLanguage
          )}
        </p>
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            size="xl"
            onClick={() => {
              try {
                window.location.href = translate(
                  MAIN_SITE_ENVIRONMENT_HOST,
                  MAIN_SITE_ENVIRONMENT_HOST_ES,
                  MAIN_SITE_ENVIRONMENT_HOST_FR,
                  MAIN_SITE_ENVIRONMENT_HOST_KO,
                  selectedLanguage
                )
              } catch (e) {
                if (DEBUG_MODE) console.log(e)
              }
            }}
            style={{
              marginRight: '20px',
              outline: '0',
              textAlign: 'center',
              lineHeight: 1.2,
            }}
            styles={(theme) => ({
              outline: '0',
              leftIcon: {
                outline: '0',
                '&:focus': {
                  outline: '0',
                },
                '&:hover': {
                  outline: '0',
                },
              },
              rightIcon: {
                outline: '0',
                '&:focus': {
                  outline: '0',
                },
                '&:hover': {
                  outline: '0',
                },
              },
              inner: {
                outline: '0',
                '&:focus': {
                  outline: '0',
                },
                '&:hover': {
                  outline: '0',
                },
              },
              root: {
                borderLeft: 'none',
                borderRight: 'none',
                backgroundImage:
                  'linear-gradient(to right, #4f1669ff, #8638a9)',
                color: '#ffffff',
                borderRadius: HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS,
                fontFamily: 'Arial, sans-serif',
                height: 'auto',
                width: 'auto',
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '20px',
                paddingRight: '20px',
                fontSize: '25px',
                outline: '0',
                opacity: 0.9,
                '&:focus': {
                  outline: '0',
                },
                '&:hover': {
                  outline: '0',
                  color: '#ffffff',
                  opacity: 0.8,
                },
                [theme.fn.smallerThan(500)]: {
                  fontSize: '25px',
                  width: isKorean(selectedLanguage) ? 'initial' : '200px',
                },
                [theme.fn.smallerThan(435)]: {
                  fontSize: '22px',
                  width: isKorean(selectedLanguage) ? 'initial' : '175px',
                },
              },
            })}
          >
            {translate(
              <>Stream Now</>,
              <>Comenzar</>,
              <>Commencer</>,
              <>
                <span aria-hidden={true} className={classes.asianTextBlock}>
                  앱
                </span>
              </>,
              selectedLanguage
            )}
          </Button>
        </div>
      </div>
    </section>
  )
}
